(function () {
    'use strict';
    var m = angular.module('dashboard');
    m.factory('policyInfoBoxes', ["policyDao", "$q", "modulesManager", "modals", "feature", "dashboardWidgetDao", "policyInfoBoxesHelper", "rolesManager", "policiesRefreshHelper", "$timeout", "$rootScope", function (policyDao, $q, modulesManager, modals, feature, dashboardWidgetDao, policyInfoBoxesHelper, rolesManager, policiesRefreshHelper, $timeout, $rootScope) {
        var policyVariants = [];
        var policyTags = [];
        var reinitFn;
        var defaults;
        var disableCache = false;
        var timeoutHandle = null;
        function propertiesDialog(boxIdx, settings, noColors, fontColors) {
            return policyInfoBoxesHelper.propertiesDialog(settings, {
                showColorSelector: !noColors,
                showFontColorSelector: fontColors,
                buttons: [{
                        label: 'Reset to default',
                        execute: function () {
                            if (!defaults) {
                                return;
                            }
                            if (defaults[settings.id]) {
                                dashboardWidgetDao.save(settings.id, defaults[settings.id].conf, true).then(function () {
                                    disableCache = true;
                                    reinitFn();
                                });
                            } else {
                                dashboardWidgetDao.remove(settings.id).then(function () {
                                    disableCache = true;
                                    reinitFn();
                                });
                            }
                        }
                    }],
                policyVariants: policyVariants,
                policyTags: policyTags
            }).then(function (data) {
                return dashboardWidgetDao.save(settings.id, data).then(function () {
                    disableCache = true;
                    reinitFn();
                });
            });
        }
        var goodColors = policyInfoBoxesHelper.goodColors;
        var goodFontColors = policyInfoBoxesHelper.goodFontColors;
        return function ($scope, logic, reinit) {
            reinitFn = reinit;
            logic.updateTick = null;
            var idxToId = logic.boxesIdxToId || _(logic.boxesAmount || 8).chain().range().map(function (idx) {
                return '' + (idx + 1);
            }).value();
            var size = 'col-lg-3 col-md-4 col-sm-4 col-xs-4';
            if (idxToId.length % 3 === 0 && idxToId.length % 4 !== 0) {
                size = 'col-lg-4 col-md-4 col-sm-6 col-xs-6';
            }
            $scope.model.widgets = $scope.model.widgets || _(idxToId).map(function () {
                return {
                    size: size,
                    type: 'info',
                    wrapper: {
                        type: 'widget-panel',
                        showLoading: true,
                        isLoading: true
                    }
                };
            });
            var defaultColors = _(idxToId).map(function (id, idx) {
                return logic.defaultColors && logic.defaultColors[idx] || goodColors[idx % goodColors.length];
            });
            var defaultFontColors = _(idxToId).map(function (id, idx) {
                return logic.defaultFontColors && logic.defaultFontColors[idx] || goodFontColors[idx % goodFontColors.length];
            });
            if (!$scope.model.defaults) {
                defaults = null;
                dashboardWidgetDao.defaults().then(function (response) {
                    defaults = $scope.model.defaults = response.data;
                });
            } else {
                defaults = $scope.model.defaults;
            }
            dashboardWidgetDao.widgetsWithData(idxToId, disableCache).then(function (response) {
                disableCache = false;
                var tags = [];
                policyVariants = _(response.data.policyCatalog).chain().filter(function (row) {
                    return row.policy_name;
                }).map(function (policy) {
                    tags.push(policy.policy_data.tags);
                    return {
                        id: policy.policy_id,
                        label: policy.policy_name
                    };
                }).value();
                policyTags = _(tags).chain().flatten().compact().unique().value();
                var infoBoxesConfig = response.data.settings;
                function processSettings(boxIdx, settings) {
                    return policyInfoBoxesHelper.processSettings(idxToId[boxIdx], settings, {
                        policyVariants: policyVariants,
                        defaultColor: defaultColors[boxIdx] || goodColors[boxIdx % goodColors.length],
                        defaultFontColor: defaultFontColors[1] || goodFontColors[boxIdx % goodFontColors.length]
                    });
                }
                function createWidget(boxIdx, settings) {
                    var widget = {
                        'type': 'info',
                        'logic': {
                            'name': 'policyInfoBox',
                            'settings': settings.conf,
                            'properties': {
                                showTypes: policyInfoBoxesHelper.showTypes,
                                periods: policyInfoBoxesHelper.periods
                            },
                            'updateTick': null,
                            'version': logic.version,
                            'noColors': logic.noColors,
                            'fontColors': logic.fontColors
                        },
                        'settings': settings,
                        'size': logic.boxesSize,
                        'class': {
                            'avanan-info-box': true,
                            'policy-info-box': true
                        },
                        'wrapper': {
                            'type': 'widget-panel',
                            'class': {
                                'avanan': true,
                                'policy-infobox': true,
                                'custom-color': true
                            },
                            'buttons': rolesManager.isActionAllowed([
                                'admin',
                                'user',
                                'operations'
                            ]) ? [{
                                    position: 'right',
                                    'class': 'policy-infobox-settings',
                                    iconClass: 'icomoon-settings-v2',
                                    execute: function () {
                                        propertiesDialog(boxIdx, settings, logic.noColors, logic.fontColors);
                                    }
                                }] : [],
                            'title': settings.widgetTitle
                        }
                    };
                    if (infoBoxesConfig[idxToId[boxIdx]]) {
                        _(infoBoxesConfig[idxToId[boxIdx]].policies).each(function (policy) {
                            widget.wrapper.class['policy_id-' + policy.policy_id] = true;
                        });
                    }
                    if (!logic.noColors) {
                        widget.wrapper.style = { 'background-color': settings.conf.color };
                    }
                    return widget;
                }
                _($scope.model.widgets).each(function (widget, idx) {
                    updateWidget(idx, infoBoxesConfig);
                });
                function updateWidget(boxIdx, infoBoxesConfig) {
                    var staticWidget = logic.staticBoxes && logic.staticBoxes[idxToId[boxIdx]];
                    if (staticWidget) {
                        if (!_($scope.model.widgets[boxIdx]).isEmpty()) {
                            return;
                        }
                        $scope.model.widgets[boxIdx] = staticWidget;
                        return;
                    }
                    var settings = processSettings(boxIdx, (infoBoxesConfig[idxToId[boxIdx]] || {}).options);
                    if (!_($scope.model.widgets[boxIdx].settings).isEqual(settings)) {
                        $scope.model.widgets[boxIdx] = createWidget(boxIdx, settings);
                    }
                    if (infoBoxesConfig[idxToId[boxIdx]]) {
                        $scope.model.widgets[boxIdx].data = {
                            findings: infoBoxesConfig[idxToId[boxIdx]].findings,
                            history: infoBoxesConfig[idxToId[boxIdx]].history,
                            policies: infoBoxesConfig[idxToId[boxIdx]].policies,
                            rightData: infoBoxesConfig[idxToId[boxIdx]].rightData
                        };
                    }
                }
                function refreshWidgetsData(ignoreTimeout) {
                    policiesRefreshHelper.triggerRefreshPolicies().then(function () {
                        dashboardWidgetDao.widgetsWithData(idxToId, disableCache).then(function (res) {
                            _($scope.model.widgets).each(function (widget, key) {
                                var newInfoBoxesConfig = res.data.settings;
                                if ($scope.model.widgets[key] && $scope.model.widgets[key].data && newInfoBoxesConfig[idxToId[key]]) {
                                    $scope.model.widgets[key].data = {
                                        findings: newInfoBoxesConfig[idxToId[key]].findings,
                                        history: newInfoBoxesConfig[idxToId[key]].history,
                                        policies: newInfoBoxesConfig[idxToId[key]].policies,
                                        rightData: newInfoBoxesConfig[idxToId[key]].rightData
                                    };
                                }
                            });
                            if (ignoreTimeout) {
                                $rootScope.$broadcast('done-refresh-analytics-page');
                            }
                        });
                    });
                    if (!ignoreTimeout) {
                        timeoutHandle = $timeout(refreshWidgetsData, 60000);
                    }
                }
                refreshWidgetsData();
                $scope.$on('do-refresh-analytics-page', function (event, data) {
                    refreshWidgetsData(true);
                });
            });
            var configListener = $scope.$on('configure-infobox', function (event, data) {
                var infoboxIdx = _($scope.model.widgets).findIndex(function (widget) {
                    return widget.settings && widget.settings.id === data.infoboxId;
                });
                if (infoboxIdx !== -1) {
                    propertiesDialog(infoboxIdx, $scope.model.widgets[infoboxIdx].settings, logic.noColors, logic.fontColors);
                }
            });
            var locationChangeListener = $scope.$on('$locationChangeStart', function (event, next) {
                if (timeoutHandle) {
                    $timeout.cancel(timeoutHandle);
                }
            });
            return function () {
                configListener();
                locationChangeListener();
            };
        };
    }]);
}());